module.exports = __webpack_public_path__ + "media/components/NewAsset/icons/insurance-family-621e498a1c02988b45fd9b1062a1d651.svg";